import {Action} from '@ngrx/store';
import {Profile} from '../profile.model';

export const SET_CHARTS_RELOAD = 'SET_CHARTS_RELOAD';
export const CLEAR_CHATS = 'CLEAR_CHARTS';
export const GET_AUDITS = 'GET_AUDITS';
export const GET_AUDITS_AUTOCOMPLETE = 'GET_AUDITS_AUTOCOMPLETE';
export const GET_AUDIT = 'GET_AUDIT';
export const SET_AUDITS = 'SET_AUDITS';
export const SET_AUDIT = 'SET_AUDIT';
export const ADD_AUDIT = 'ADD_AUDIT';
export const GET_AUDIENCE_STAT = 'GET_AUDIENCE_STAT';
export const SET_AUDIENCE_STAT = 'SET_AUDIENCE_STAT';
export const GET_AUDIENCE_INTEREST = 'GET_AUDIENCE_INTEREST';
export const SET_AUDIENCE_INTEREST = 'SET_AUDIENCE_INTEREST';
export const GET_AUDIENCE_LOCATION = 'GET_AUDIENCE_LOCATION';
export const SET_AUDIENCE_LOCATION = 'SET_AUDIENCE_LOCATION';
export const GET_FOLLOWER_STAT = 'GET_FOLLOWER_STAT';
export const SET_FOLLOWER_STAT = 'SET_FOLLOWER_STAT';
export const GET_FOLLOWER_ENGAGE = 'GET_FOLLOWER_ENGAGE';
export const SET_FOLLOWER_ENGAGE = 'SET_FOLLOWER_ENGAGE';
export const GET_FOLLOWER_ENGAGE_INDICATOR = 'GET_FOLLOWER_ENGAGE_INDICATOR';
export const SET_FOLLOWER_ENGAGE_INDICATOR = 'SET_FOLLOWER_ENGAGE_INDICATOR';
export const GET_MEDIA_STAT = 'GET_MEDIA_STAT';
export const SET_MEDIA_STAT = 'SET_MEDIA_STAT';
export const GET_MEDIA_ANALYZE = 'GET_MEDIA_ANALYZE';
export const SET_MEDIA_ANALYZE = 'SET_MEDIA_ANALYZE';
export const GET_MEDIA_COMMENT_ANALYZE = 'GET_MEDIA_COMMENT_ANALYZE';
export const SET_MEDIA_COMMENT_ANALYZE = 'SET_MEDIA_COMMENT_ANALYZE';
export const GET_PROFILE_DETAIL = 'GET_PROFILE_DETAIL';
export const SET_PROFILE_DETAIL = 'SET_PROFILE_DETAIL';
export const GET_PROFILE_PROGRESS = 'GET_PROFILE_PROGRESS';
export const SET_PROFILE_PROGRESS = 'SET_PROFILE_PROGRESS';
export const SET_LOADER = 'SET_LOADER';
export const GET_AUTOLOAD = 'GET_AUTOLOAD';
export const SET_AUTOLOAD = 'SET_AUTOLOAD';
export const GET_PROFILE_MEDIA = 'GET_PROFILE_MEDIA';
export const SET_PROFILE_MEDIA = 'SET_PROFILE_MEDIA';
export const GET_PROFILE_SCORE = 'GET_PROFILE_SCORE';
export const SET_PROFILE_SCORE = 'SET_PROFILE_SCORE';
export const UPDATE_PROFILE_STATUS = 'UPDATE_PROFILE_STATUS';
export const SET_AUDIT_BOX_EXAMPLE_STATUS = 'SET_AUDIT_BOX_EXAMPLE_STATUS';
export const ADD_AUDIT_CHECK = 'ADD_AUDIT_CHECK';
export const GET_AUDIT_CHECK = 'GET_AUDIT_CHECK';
export const SET_AUDIT_ID = 'SET_AUDIT_ID';
export const RESET_AUDIT_ID = 'RESET_AUDIT_ID';
export const GET_USERS_RANK = 'GET_USERS_RANK';
export const SET_USERS_RANK = 'SET_USERS_RANK';

export const GET_PROFILE_AUDIENCE_TIKTOK = 'GET_PROFILE_AUDIENCE_TIKTOK';
export const SET_PROFILE_AUDIENCE_TIKTOK = 'SET_PROFILE_AUDIENCE_TIKTOK';

export class SetChartsReload implements Action {
  readonly type = SET_CHARTS_RELOAD;

  constructor(public payload: string) {}
}

export class ClearCharts implements Action {
  readonly type = CLEAR_CHATS;
}

export class GetAudits implements Action {
  readonly type = GET_AUDITS;

  constructor(public payload: {params: any}) {
  }
}

export class GetAuditsAutocomplete implements Action {
  readonly type = GET_AUDITS_AUTOCOMPLETE;

  constructor(public payload: {params: any}) {
  }
}

export class GetAudit implements Action {
  readonly type = GET_AUDIT;

  constructor(public payload: {id: number, params: any}) {}
}

export class SetAudits implements Action {
  readonly type = SET_AUDITS;

  constructor(public payload: Profile[]) {}
}

export class SetAudit implements Action {
  readonly type = SET_AUDIT;

  constructor(public payload: Profile) {}
}

export class AddAudit implements Action {
  readonly type = ADD_AUDIT;

  constructor(public payload: { profile: string, channelType: string, redirect: boolean }) {}
}

export class GetAudienceStat implements Action {
  readonly type = GET_AUDIENCE_STAT;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export class SetAudienceStat implements Action {
  readonly type = SET_AUDIENCE_STAT;

  constructor(public payload: any) {}
}

export class GetAudienceInterest implements Action {
  readonly type = GET_AUDIENCE_INTEREST;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export class SetAudienceInterest implements Action {
  readonly type = SET_AUDIENCE_INTEREST;

  constructor(public payload: any) {
  }
}

export class GetAudienceLocation implements Action {
  readonly type = GET_AUDIENCE_LOCATION;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export class SetAudienceLocation implements Action {
  readonly type = SET_AUDIENCE_LOCATION;

  constructor(public payload: any) {
  }
}

export class GetFollowerStat implements Action {
  readonly type = GET_FOLLOWER_STAT;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export class SetFollowerStat implements Action {
  readonly type = SET_FOLLOWER_STAT;

  constructor(public payload: any) {}
}

export class GetFollowerEngage implements Action {
  readonly type = GET_FOLLOWER_ENGAGE;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export class SetFollowerEngage implements Action {
  readonly type = SET_FOLLOWER_ENGAGE;

  constructor(public payload: any) {
  }
}

export class GetFollowerEngageIndicator implements Action {
  readonly type = GET_FOLLOWER_ENGAGE_INDICATOR;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export class SetFollowerEngageIndicator implements Action {
  readonly type = SET_FOLLOWER_ENGAGE_INDICATOR;

  constructor(public payload: any) {
  }
}

export class GetMediaStat implements Action {
  readonly type = GET_MEDIA_STAT;

  constructor(public payload: {id: number, params: any}) {}
}

export class SetMediaStat implements Action {
  readonly type = SET_MEDIA_STAT;

  constructor(public payload: any) {}
}

export class GetMediaAnalyze implements Action {
  readonly type = GET_MEDIA_ANALYZE;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export class SetMediaAnalyze implements Action {
  readonly type = SET_MEDIA_ANALYZE;

  constructor(public payload: any) {
  }
}

export class GetMediaCommentAnalyze implements Action {
  readonly type = GET_MEDIA_COMMENT_ANALYZE;

  constructor(public payload: {id: number, type: number, params: any}) {}
}

export class SetMediaCommentAnalyze implements Action {
  readonly type = SET_MEDIA_COMMENT_ANALYZE;

  constructor(public payload: any) {
  }
}

export class GetProfileDetail implements Action {
  readonly type = GET_PROFILE_DETAIL;

  constructor(public payload: {id: number, params: any}) {}
}

export class SetProfileDetail implements Action {
  readonly type = SET_PROFILE_DETAIL;

  constructor(public payload: any) {
  }
}

export class GetProfileProgress implements Action {
  readonly type = GET_PROFILE_PROGRESS;

  constructor(public payload: {id: number, params: any}) {}
}

export class SetProfileProgress implements Action {
  readonly type = SET_PROFILE_PROGRESS;

  constructor(public payload: any) {
  }
}

export class SetLoader implements Action {
  readonly type = SET_LOADER;

  constructor(public payload: {module: string, box: string, value: boolean}) {}
}

export class GetAutoload implements Action {
  readonly type = GET_AUTOLOAD;

  constructor(public payload: {id: number, code: string}) {}
}

export class SetAutoload implements Action {
  readonly type = SET_AUTOLOAD;

  constructor(public payload: boolean) {}
}

export class GetProfileMedia implements Action {
  readonly type = GET_PROFILE_MEDIA;

  constructor(public payload: {id: number, params: any}) {}
}

export class SetProfileMedia implements Action {
  readonly type = SET_PROFILE_MEDIA;

  constructor(public payload: any[]) {}
}

export class GetProfileScore implements Action {
  readonly type = GET_PROFILE_SCORE;

  constructor(public payload: {id: number, params: any}) {}
}

export class SetProfileScore implements Action {
  readonly type = SET_PROFILE_SCORE;

  constructor(public payload: any) {}
}

export class UpdateProfileStatus implements Action {
  readonly type = UPDATE_PROFILE_STATUS;

  constructor(public payload: {profileId: number, status: number}) {}
}

export class SetAuditBoxExampleStatus implements Action {
  readonly type = SET_AUDIT_BOX_EXAMPLE_STATUS;

  constructor(public payload: {boxName: string, status: boolean}) {
  }
}

export class AddAuditCheck implements Action {
  readonly type = ADD_AUDIT_CHECK;

  constructor(public payload: {profile: string, channelType: string, redirect: boolean}) {}
}

export class GetAuditCheck implements Action {
  readonly type = GET_AUDIT_CHECK;

  constructor(public payload: {uid: string, redirect: boolean}) {}
}

export class SetAuditId implements Action {
  readonly type = SET_AUDIT_ID;

  constructor(public payload: {id: number}) {}
}

export class ResetAuditId implements Action {
  readonly type = RESET_AUDIT_ID;
}

export class GetUsersRank implements Action {
  readonly type = GET_USERS_RANK;

  constructor(public payload: {
    id: number, type: number, limit: number, offset: number, sortField: string, sortType: string, params: any
  }) {
  }
}

export class SetUsersRank implements Action {
  readonly type = SET_USERS_RANK;

  constructor(public payload: any) {
  }
}

export class GetProfileAudienceTiktok implements Action {
  readonly type = GET_PROFILE_AUDIENCE_TIKTOK;

  constructor(public payload: {id: number, params: any}) {}
}

export class SetProfileAudienceTiktok implements Action {
  readonly type = SET_PROFILE_AUDIENCE_TIKTOK;

  constructor(public payload: any) {}
}

export type ProfileActions = GetAudit | GetAudits | SetAudit | SetAudits | AddAudit | GetAudienceStat | SetAudienceStat
  | GetFollowerStat | SetFollowerStat | GetMediaStat | SetMediaStat | GetAudienceInterest | SetAudienceInterest
  | GetAudienceLocation | SetAudienceLocation | GetMediaAnalyze | SetMediaAnalyze | GetProfileDetail | SetProfileDetail
  | GetFollowerEngage | SetFollowerEngage | SetChartsReload | GetMediaCommentAnalyze | SetMediaCommentAnalyze | ClearCharts
  | GetFollowerEngageIndicator | SetFollowerEngageIndicator | GetProfileProgress | SetProfileProgress | SetLoader
  | GetAutoload | SetAutoload | GetProfileMedia | SetProfileMedia | GetProfileScore | SetProfileScore | UpdateProfileStatus
  | SetAuditBoxExampleStatus | AddAuditCheck | GetAuditCheck | GetAuditsAutocomplete | SetAuditId | ResetAuditId
  | GetUsersRank | SetUsersRank
  | GetProfileAudienceTiktok | SetProfileAudienceTiktok
  ;
